import React from 'react';
import { connect } from 'react-redux';
import { AppState, ConnectedPropsWithoutDispatch } from '../../../../stores/redux-store';
import { applicationParameters } from '../../../../utilities/application-parameters';
import { resetCredentials as resetCredentialsConnect } from '../../../../stores/credentials-store';
import { useConfiguration } from '../../../../components/ApplicationProviders/ConfigurationProvider/ConfigurationProvider';
import { isMultibanking } from '../../../../models/configuration';
import { IncomeCheckMachineView as IncomeCheckMachineViewImport } from './IncomeCheckMachineView';
import { IncomeCheckMachineViewProps } from './incomeCheckMachine';

export type IncomeCheckDirectorProps = PropsFromRedux & {
  IncomeCheckMachineView: React.ComponentType<IncomeCheckMachineViewProps>;
};

export const IncomeCheckDirectorPresenter = ({
  session,
  resetCredentials,
  IncomeCheckMachineView = IncomeCheckMachineViewImport,
}: IncomeCheckDirectorProps) => {
  const engineVersion = applicationParameters.get('engineVersion');
  const externalReference =
    session?.externalReference || applicationParameters.get('externalReference');
  const { data: configurationData } = useConfiguration();
  const isMultiBanking = isMultibanking(configurationData);

  return (
    <IncomeCheckMachineView
      externalReference={externalReference}
      onCancel={resetCredentials}
      engineVersion={engineVersion}
      isMultibanking={isMultiBanking}
    />
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    session: state.session.data,
  };
};

const connector = connect(mapStateToProps, {
  resetCredentials: resetCredentialsConnect,
});

type PropsFromRedux = ConnectedPropsWithoutDispatch<typeof connector>;

export const IncomeCheckDirector = connector(IncomeCheckDirectorPresenter);
